module.exports = __webpack_public_path__ + "static/media/asterisk.6ca6bd33.svg";